// Vuex project module actions

import { API } from '@/config';
import { FILL_CURRENT_LIST, FILL_LIST } from './mutations-types';

export default {

  async getCurrentList({ commit }) {
    try {
      const { records } = (await API.get('client/holiday/getCurrentList')).data.data;
      commit(FILL_CURRENT_LIST, { records });
    } catch (e) {
      console.log(e);
    }
  },

  async createHoliday(context, element) {
    try {
      await API.put('/project/holiday/createHoliday', { ...element });
    } catch (err) {
      console.log(err);
    }
  },
  async updateHoliday(context, params) {
    try {
      await API.patch('/project/holiday/updateHoliday', { ...params });
    } catch (err) {
      console.log(err);
    }
  },
  async removeHoliday(context, holiday) {
    try {
      await API.patch('/project/holiday/removeHoliday', holiday);
    } catch (err) {
      console.log(err);
    }
  },
  async getList({ commit }, project) {
    try {
      const params = {
        project,
      };
      const { records, total } = (await API.get('project/holiday/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (e) {
      console.log(e);
    }
  },
};
